module.exports = __webpack_public_path__ + "static/badge_small_tool-1a882ffb52d5ccf846fab5c96cb27383.svg";